<div class="feed-school" [class.mobile]="deviceService.isMobile()"><h2
  class="title">{{ 'school-main-tabs.feed' | translate }}</h2>

  <div class="feed-item" *ngIf="meIsOwnerSchool && pathName !== 'main'">
    <app-feed-post-form (posted)="onContentPosted()" [schoolId]="school?.id"></app-feed-post-form>

  </div>

  <div *ngIf="debug$ | async">
    <input type="text" [value]="dbgContentId" (change)="dbgContentId = $event.target.value" placeholder="content id">
    <button class="button secondary" (click)="dbgPostToSchool()">post to school</button>
  </div>

  <ng-template ngFor let-item [ngForOf]="content.items" let-i="index" [ngForTrackBy]="trackContentByFn">
    <app-content-card [item]="item" [inline]="true" [cut]="true"></app-content-card>
  </ng-template>

  <app-pagination
    [enabled]="content.loaded"
    [loading]="content.loading"
    [pagination]="content.pagination"
    [nothingMoreText]="''"
    baseUrl=""
    (nextPage)="nextPage()">
  </app-pagination>
</div>
